import { ReactComponent as ArrowLeft } from "icons/arrowLeft.svg";
import { ReactComponent as Attach } from "icons/attach.svg";
import { ReactComponent as Bell } from "icons/bell.svg";
import { ReactComponent as Camera } from "icons/camera.svg";
import { ReactComponent as CameraPlus } from "icons/cameraplus.svg";
import { ReactComponent as Cards } from "icons/cards.svg";
import { ReactComponent as Chat } from "icons/chat.svg";
import { ReactComponent as Reset } from "icons/clear.svg";
import { ReactComponent as Clear } from "icons/clear.svg";
import { ReactComponent as Edit } from "icons/edit.svg";
import { ReactComponent as Eye } from "icons/eye.svg";
import { ReactComponent as Facebook } from "icons/facebook.svg";
import { ReactComponent as Files } from "icons/files.svg";
import { ReactComponent as Hamburger } from "icons/hamburger.svg";
import { ReactComponent as Home } from "icons/home.svg";
import { ReactComponent as Information } from "icons/information.svg";
import { ReactComponent as Keyboard } from "icons/keyboard.svg";
import { ReactComponent as Left } from "icons/left.svg";
import { ReactComponent as Linkedin } from "icons/linkedin.svg";
import { ReactComponent as Microphone } from "icons/microphone.svg";
import { ReactComponent as Person } from "icons/person.svg";
import { ReactComponent as Phone } from "icons/phone.svg";
import { ReactComponent as Refresh } from "icons/refresh.svg";
import { ReactComponent as Right } from "icons/right.svg";
import { ReactComponent as Search } from "icons/search.svg";
import { ReactComponent as Send } from "icons/send.svg";
import { ReactComponent as Settings } from "icons/settings.svg";
import { ReactComponent as Smile } from "icons/smile.svg";
import { ReactComponent as Star } from "icons/star.svg";
import { ReactComponent as Twitter } from "icons/twitter.svg";
import { ReactComponent as YouTube } from "icons/youtube.svg";

const Icons = {
    ArrowLeft,
    Attach,
    Bell,
    Camera,
    CameraPlus,
    Cards,
    Chat,
    Clear,
    Edit,
    Eye,
    Facebook,
    Files,
    Hamburger,
    Home,
    Information,
    Keyboard,
    Linkedin,
    Left,
    Microphone,
    Person,
    Phone,
    Refresh,
    Reset,
    Search,
    Send,
    Settings,
    Smile,
    Star,
    Right,

    Twitter,
    YouTube,
};

export default Icons;
